$(document).ready(function () {
  // $(".sf__product-listing .sf__col-item:nth-child(12)").after('<img class="xl\:px-3 only_mobile_view py-1.5 add_image" height="100%" width="100%" src="https://cdn.shopify.com/s/files/1/0564/7420/6346/files/Rectangle_739_1-1.png?v=1689915704" alt="Image">'); 
  // $(".sf__product-listing .sf__col-item:nth-child(21)").after('<img class="xl\:px-3 only_mobile_view py-1.5 add_image" height="100%" width="100%" src="https://cdn.shopify.com/s/files/1/0564/7420/6346/files/Rectangle_739_1-2.png?v=1689915709" alt="Image">'); 
  // $(".sf__product-listing .sf__col-item:nth-child(30)").after('<img class="xl\:px-3 only_mobile_view py-1.5 add_image" height="100%" width="100%" src="https://cdn.shopify.com/s/files/1/0564/7420/6346/files/Rectangle_739_1.png?v=1689915710" alt="Image">');  
  // $('#play-video').on('click', function(e){
  //   e.preventDefault();
  //   $('#video-overlay').addClass('open');
  //   $("#video-overlay").append('<iframe width="560" height="315" src="https://www.youtube.com/embed/ngElkyQ6Rhs" frameborder="0" allowfullscreen></iframe>');
  // });

  $(window).scroll(function () {
    $(".sf__collection-toolbar").removeClass("hide");
    if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100)) {
      //you are at bottom
      $(".prod__sticky-atc ").addClass("translate-y-full");
      $(".sf__collection-toolbar").addClass("hide");
    }
  });


  $(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() > ($(document).height() - 800)) {
      $(".mobile_color_option").css("display", "none");
    }
  });

  $("#myInvoiceForm").submit(function (event) {
    event.preventDefault();

    var customer_id = $("#customer_id").val();
    var business_nature = $("#business_nature").val();
    var image = $("#image")[0].files[0];
    var customer_name = $("#customer_name").val();
    var customer_email = $("#customer_email").val();
    var customer_phone = $("#customer_phone").val();
    var customer_amount = $("#customer_amount").val();

    if (!customer_id || !business_nature || !customer_phone || !customer_amount || !customer_email || !image) {
      $("#invmessage").html("Please fill in all fields.");
      return;
    }

    if (image.size > 1024000) {
      $("#invmessage").html("Invoice file not allow more than 500MB");
      return;
    }

    if (customer_phone.length != 10) {
      $("#invmessage").html("Please enter valid mobile no.");
      return;
    }

    var formData = new FormData();
    formData.append("customer_id", customer_id);
    formData.append("source_name", business_nature);
    formData.append("invoice_file", image);
    formData.append("customer_name", customer_name);
    formData.append("customer_email", customer_email);
    formData.append("customer_phone", customer_phone);
    formData.append("invoice_amount", customer_amount);

    $.ajax({
      url: "https://app.fashiondream.co.in/b2cfashion/get_invoice.php",
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: function () {
        $("#sub_process").hide();
        $("#invmessage").html("Sending data...");
      },
      success: function (response) {
        $("#invmessage").html(response);
        $("#sub_process").show();
      },
      error: function (xhr, status, error) {
        console.error(xhr);
        $("#sub_process").show();
        $("#invmessage").html("An error occurred: " + error);
      }
    });
  });

  $('.moreless-button').click(function () {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });

  $('.del_check').submit(function () {
    var text_value = $('#dataInput').val();
    if (text_value = '') {
      alert("enter")
    }

  });
  var mytext = $('.col1').text();
  if (mytext != '') {
    $('.col2').css("display", "block");
  }

  $(function () {
    $('.col1').each(function () {
      if ($.trim($(this).html()) == '')
        $('.coll_blocks').hide();
    });
  });

  $('#other_field').click(function (e) {
    $("#other_value").css("display", "block");
  });

  $('.variant-picker__option').click(function (e) {
    $(".mobile_color_option").css("display", "none");
  });

  $('.color_close').click(function (e) {
    $(".mobile_color_option").css("display", "none");
    $("#shopify-section-template--15908933632138__product-recommendations").css('display', 'block');
    $('.sf-image').css("z-index", "99");
    // $('.sf-prod-media').css("z-index","99");
  });
  $(".combined-shape").click(function () {
    $('.prod__option--image.mobile_color_option').slideToggle("slow");

    // $('.sf-prod-media').css("z-index","-1");
    $("#shopify-section-template--15908933632138__product-recommendations").css('display', 'none');
  });

  $(".door_video_click").click(function () {

    $('.video_door').css('display', 'block');
    $(".video_door video").click();
    $('.door_video_click').css('display', 'none');

    setTimeout(function () {
      $(".video_code").animate({ bottom: '13%' }, 'slow');
      $('.video_code').css('display', 'block');
    }, 5000);
  });

  $(document).ready(function () {
    //$('#myRewardModal').show();
    var $anchor = $('.gift_reward_class a');
    if (ShopifyAnalytics.meta.page.customerId != undefined) {
      $anchor.attr('href', 'https://fashiondream.co.in/pages/upload-invoice');
    }
  });
  $('#closeRewardModal').click(function (e) {
    $('#myRewardModal').hide();
  });

  if (ShopifyAnalytics.meta.page.customerId != undefined) {
    //console.log('Customer is logged in ok '+ShopifyAnalytics.meta.page.customerId);
    if ($('#inv_total_rewds, #inv_total_rows').length) {
      jQuery.ajax({
        url: "https://app.fashiondream.co.in/b2cfashion/invoice_api.php?customer_id=" + ShopifyAnalytics.meta.page.customerId,
        type: "POST",
        data: {},
        beforeSend: function () {
          $("#inv_total_rows").html("Loading rewards....");
        },
        success: function (res) {
          //console.log('Customer is logged in ok '+res.point+'---'+res.tr_rows);
          $('#inv_total_rewds').html(res.point);
          $('#inv_total_rows').html(res.tr_rows);
          if (res.is_regi_point > 0) {
            $('#is_regi_point').hide();
          }
          $('.mobileInvoiceForm').html(res.mobile_row);

          $('.show_history_click').click(function (e) {
            $('.show_history_data').toggle();
          });
          $('.wallet_show_history_click').click(function (e) {
            $('#wallet_form_tr').hide();
            $('.wallet_show_history_data').toggle();
          });


          $('.get_signup_reward').click(function (e) {
            var customer_name = $("#customer_name").val();
            var customer_email = $("#customer_email").val();
            jQuery.ajax({
              url: "https://app.fashiondream.co.in/b2cfashion/invoice_customer_point_api.php?customer_id=" + ShopifyAnalytics.meta.page.customerId + "&name=" + customer_name + "&email=" + customer_email,
              type: "POST",
              data: {},
              success: function (res) {
                if (res.success > 0) {
                  $('.show_signup_reward').show();
                } else {
                  alert(res.msg);
                }
              }
            });
          });

          $('#sub_process').click(function (e) {
            var customer_id = $("#customer_id").val();
            var business_nature = $("#business_nature").val();
            var image = $("#image")[0].files[0];
            var customer_name = $("#customer_name").val();
            var customer_email = $("#customer_email").val();
            var customer_phone = $("#customer_phone").val();
            var customer_amount = $("#customer_amount").val();

            if (!business_nature || !customer_phone || !customer_amount || !image) {
              $("#invmessage").html("<span style='color:red;'>Please fill in all fields.</span>");
              $("#invmessagemobile").html("<span style='color:red;'>Please fill in all fields.</span>");
              return;
            }

            if (image.size > 1024000) {
              $("#invmessage").html("<span style='color:red;'>Invoice file not allow more than 500MB</span>");
              $("#invmessagemobile").html("<span style='color:red;'>Invoice file not allow more than 500MB</span>");
              return;
            }

            if (customer_phone.length != 10) {
              $("#invmessage").html("<span style='color:red;'>Please enter valid mobile no.</span>");
              $("#invmessagemobile").html("<span style='color:red;'>Please enter valid mobile no.</span>");
              return;
            }
            var formData = new FormData();
            formData.append("customer_id", customer_id);
            formData.append("source_name", business_nature);
            formData.append("invoice_file", image);
            formData.append("customer_name", customer_name);
            formData.append("customer_email", customer_email);
            formData.append("customer_phone", customer_phone);
            formData.append("invoice_amount", customer_amount);

            $.ajax({
              url: "https://app.fashiondream.co.in/b2cfashion/get_invoice.php",
              type: "POST",
              data: formData,
              processData: false,
              contentType: false,
              beforeSend: function () {
                $("#sub_process").hide();
                $("#invmessage").html("Sending data...");
                $("#invmessagemobile").html("Sending data...");
              },
              success: function (response) {
                $("#invmessage").html(response);
                $("#sub_process").show();
                location.reload(true);
              },
              error: function (xhr, status, error) {
                console.error(xhr);
                $("#sub_process").show();
                $("#invmessage").html("<span style='color:red;'>An error occurred: " + error + "</span>");
                $("#invmessagemobile").html("<span style='color:red;'>An error occurred: " + error + "</span>");
              }
            });
          });
          // Mobile js
          $('#sub_process_mobile').click(function (e) {

            var customer_id = $("#customer_id_mobile").val();
            var business_nature = $("#business_nature_mobile").val();
            var image = $("#image_mobile")[0].files[0];
            var customer_name = $("#customer_name_mobile").val();
            var customer_email = $("#customer_email_mobile").val();
            var customer_phone = $("#customer_phone_mobile").val();
            var customer_amount = $("#customer_amount_mobile").val();

            if (!business_nature || !customer_phone || !customer_amount || !image) {
              $("#invmessage").html("<span style='color:red;'>Please fill in all fields.</span>");
              $("#invmessagemobile").html("<span style='color:red;'>Please fill in all fields.</span>");
              return;
            }

            if (image.size > 1024000) {
              $("#invmessage").html("<span style='color:red;'>Invoice file not allow more than 500MB</span>");
              $("#invmessagemobile").html("<span style='color:red;'>Invoice file not allow more than 500MB</span>");
              return;
            }

            if (customer_phone.length != 10) {
              $("#invmessage").html("<span style='color:red;'>Please enter valid mobile no.</span>");
              $("#invmessagemobile").html("<span style='color:red;'>Please enter valid mobile no.</span>");
              return;
            }
            var formData = new FormData();
            formData.append("customer_id", customer_id);
            formData.append("source_name", business_nature);
            formData.append("invoice_file", image);
            formData.append("customer_name", customer_name);
            formData.append("customer_email", customer_email);
            formData.append("customer_phone", customer_phone);
            formData.append("invoice_amount", customer_amount);

            $.ajax({
              url: "https://app.fashiondream.co.in/b2cfashion/get_invoice.php",
              type: "POST",
              data: formData,
              processData: false,
              contentType: false,
              beforeSend: function () {
                $("#sub_process").hide();
                $("#invmessage").html("Sending data...");
                $("#invmessagemobile").html("Sending data...");
              },
              success: function (response) {
                $("#invmessage").html(response);
                $("#sub_process").show();
                location.reload(true);
              },
              error: function (xhr, status, error) {
                console.error(xhr);
                $("#sub_process").show();
                $("#invmessage").html("<span style='color:red;'>An error occurred: " + error + "</span>");
                $("#invmessagemobile").html("<span style='color:red;'>An error occurred: " + error + "</span>");
              }
            });
          });


        }
      });
    }
    if ($('#checkout_rewards').length) {
      jQuery.ajax({
        url: "https://app.fashiondream.co.in/b2cfashion/invoice_reward_get.php?customer_id=" + ShopifyAnalytics.meta.page.customerId,
        type: "POST",
        data: {},
        beforeSend: function () {
          $("#checkout_rewards").hide();
        },
        success: function (res) {
          var rewDetail = res;
          if (res.point == 0) {
            $("#checkout_rewards").hide();
          } else {
            $("#checkout_rewards").show();
            $('#checkout_rewards_text').html(res.msg);
          }
        }
      });
    }
  }

  /* b2b form submit */
  $(function () {
    $('#business_nature').change(function () {
      if ($(this).val() === 'Other') {
        $('#other_value').css('display', 'block');
      } else {
        $('#other_value').css('display', 'none');
      }
    });
  });

  $(function () {
    $('#Interested').change(function () {
      if ($(this).val() === 'Buying') {
        $('.check_box').css('display', 'grid');
      } else {
        $('.check_box').css('display', 'none');
      }
    });
  });

  $('#first_name, #last_name, #company, #city, #province').keydown(function (e) {
    if (e.ctrlKey || e.altKey) {
      e.preventDefault();
    } else {
      var key = e.keyCode;
      if (!((key == 8) || (key == 32) || (key == 46) || (key >= 35 && key <= 40) || (key >= 65 && key <= 90))) {
        e.preventDefault();
      }
    }
  });

  $('#address1, #message').bind('keypress', function (event) {
    var regex = new RegExp("^[a-zA-Z0-9 \b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  });

  $('#zip, #phone, #customer_phone').bind('keypress', function (event) {
    var regex = new RegExp("^[0-9\b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  });

  $(document).on('click', '#b2binquirydatabtn', function () {
    var b2binquirydata = $('#b2binquirydata').serialize();
    var b2b_name = $("#name").val();
    var b2b_phone = $("#phone").val();
    var b2b_email = $("#email").val();
    var b2b_company = $("#company").val();
    var b2b_password = $("#password").val();
    var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    var mobile_expr = /^[0-9]{10}$/;
    $('#b2berror').html("");
    $('#b2bsuccess').html("");

    if (b2b_name == '') {
      $('#b2bsuccess').html("");
      $('#b2berror').html("Please enter all * required data.");
      return false;
    }
    if (b2b_email != '' && !pattern.test(b2b_email)) {
      $('#b2bsuccess').html("");
      $('#b2berror').html("Please enter valid email.");
      return false;
    }
    if (b2b_phone == '') {
      $('#b2bsuccess').html("");
      $('#b2berror').html("Please enter all * required data.");
      return false;
    }
    if (b2b_phone != '' && b2b_phone.length != 10 && !mobile_expr.test(b2b_phone)) {
      $('#b2bsuccess').html("");
      $('#b2berror').html("Please enter valid phone number (10 digit only, without 91 OR +91).");
      return false;
    }
    if (b2b_password == '') {
      $('#b2bsuccess').html("");
      $('#b2berror').html("Please enter all * required data.");
      return false;
    }
    if (b2b_company == '') {
      $('#b2bsuccess').html("");
      $('#b2berror').html("Please enter all * required data.");
      return false;
    }


    if (pattern.test(b2b_email)) {
      jQuery.ajax({
        url: "https://app.fashiondream.co.in/b2bfashion/b2c_inquiry",
        type: "POST",
        dataType: "json",
        contentType: "application/x-www-form-urlencoded",
        data: {
          b2c_data: b2binquirydata,
        },
        success: function (e) {
          if (e.status) {
            $('#b2binquirydata')[0].reset();
            $('#b2bsuccess').html("");
            $('#b2berror').html("");
            alert(e.msg);
            window.location = "https://b2b.fashiondream.co.in/account/login";
          }
          else {
            $('#b2bsuccess').html("");
            $('#b2berror').html(e.msg);
          }
        },
        error: function (e) {
          if (e && e.status === 202) {

          } else {
            if (e.responseText) {
              $('#b2berror').html(e.responseText);
            }
          }
        },
      });
    } else {
      $('#b2bsuccess').html("");
      $('#b2berror').html('Enter valid email id');
      return false;
    }
  });

  /* b2b form submit END */
  $('.popup-close').click(function (e) {
    $(".similar_product").css("display", "none");
  });
  $('.view_similar').click(function (e) {
    $(".similar_product").css("display", "block");
  });
  $('.video').click(function (e) {
    $(".video-section").css("display", "block");
    $('.video-homepage').get(0).play()
  });
  $('.video-section').click(function () {
    $(".video-section").css("display", "none");
    $('.video-homepage').get(0).pause()
  })
  $('.close_video').click(function (e) {
    $(".video-section").css("display", "none");
    $('.video-homepage').get(0).pause()
  });

  $('.size_chart_kids').click(function (e) {
    if ($(".modal_kid_size_chart")[0]) {
      $(".size_chart_kids").css("display", "block");
      $(".size_chart").css("display", "none");
    }
  });
  $(".tag-filter a").text(function () {
    return $(this).text().replace("color-", "");
  });
  $('.ask_btn').click(function (e) {
    $(".ask_contact").css("display", "block");
  });
  $(".share_custom").click(function () {
    $('.social_share').animate({ bottom: '0px' }, 'slow', function () {
      $('.social_share').css('display', 'block');

    });
    $('.share_close').click(function (e) {
      $(".social_share").css("display", "none");
    });
  });

  $('.responsive_slider1').slick({
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.influencer_video').slick({
    // speed: 1000,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    autoplay: false,
    slidesToScroll: 1,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.influencer_video').mouseover(function () {
    $(this).slick('play')
  });
  $('.influencer_video').mouseout(function () {
    $(this).slick('pause')
  });

  $('.responsive').slick({
    infinite: false,
    speed: 300,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });



  $('.responsive_slider2').slick({
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  $(function () {
    $('.popup-youtube, .popup-vimeo').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  });
  $('.tab_slider').slick({
    // speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    // speed: 2000,
    infinite: false,
    // centerMode: true,
    // centerPadding: '60px',
    loop: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  });


  $(window).scroll(function () {

    if ($(this).scrollTop() > 1) {
      $('.header__wrapper').addClass("fixed_header");
      $('.announcement-bar').addClass("fixed_announcment");

    }
    else {
      $('.header__wrapper').removeClass("fixed_header");
      $('.announcement-bar').removeClass("fixed_announcment");
    }

    var targetHeight = $("#CollectionProductGrid").height() - 600;


    var targetHeightfilter = $(".sf__filter-wrapper").height();

    if ($(this).scrollTop() > targetHeightfilter) {
      $('.sf__sidebar-content').addClass('fixed_filter');
    } else {
      $('.sf__sidebar-content').removeClass('fixed_filter');
    }
    if ($(this).scrollTop() <= 0) {
      $('.sf__sidebar-content').removeClass('fixed_filter');
    }

    if ($(this).scrollTop() >= targetHeight) {
      $('.sf__sidebar-content').removeClass('fixed_filter');
    }
  });

  $('.bulk_submit').submit(function (event) {
    event.preventDefault();
    window.location.href = 'https://fashiondreamwholesale.in/';
  });
  $('#myForm').submit(function (event) {
    event.preventDefault();
    $('.display_data').css('display', 'block');
  });
  $('.size_checkbox').click(function () {
    if ($(this).is(':checked')) {
      $('li.sf__option-filter a').trigger('click');
    }
  });
  $('.custom_size').click(function (e) {
    e.preventDefault();
    var clickedValue = $(this).find('input').val();
    $(this).css("font-weight", "500");
    $(this).css("color", "green");
    $('.variant-picker__option input[type="radio"]').removeAttr('checked');

    $('.variant-picker__option input').each(function () {
      var inputValue = $(this).val();
      if (inputValue === clickedValue) {
        $(this).prop('checked', true);
        var rid = $(this).attr("data-id");
        $('.variant-picker__button .selected-value.option-label').text(clickedValue);
        $('.variant-picker__field').attr('data-selected-value', clickedValue);
        $('.variant-picker__button .selected-value.option-label').trigger('click');
        $('.variant-picker__button .selected-value.option-label').click();
        $('.' + rid).trigger('click');
        $("input[name='id']").val(rid);

        $(".combined-variant option:selected").each(function () {
          $(this).removeAttr('selected');
        });
        $('.combined-variant option[value=' + rid + ']').attr('selected', 'selected');
        $(".combined-variant").val(rid).change();
      }
    });
  });

  $('.size_radio').click(function (e) {
    var clickedValue = $(this).val();
    $('.variant-picker__option input[type="radio"]').removeAttr('checked');

    $('.variant-picker__option input').each(function () {
      var inputValue = $(this).val();
      if (inputValue === clickedValue) {
        $(this).prop('checked', true);
        var rid = $(this).attr("data-id");
        $('.variant-picker__button .selected-value.option-label').text(clickedValue);
        $('.variant-picker__field').attr('data-selected-value', clickedValue);
        $('.variant-picker__button .selected-value.option-label').trigger('click');
        $('.variant-picker__button .selected-value.option-label').click();
        $('.' + rid).trigger('click');
        $("input[name='id']").val(rid);

        $(".combined-variant option:selected").each(function () {
          $(this).removeAttr('selected');
        });
        $('.combined-variant option[value=' + rid + ']').attr('selected', 'selected');
        $(".combined-variant").val(rid).change();
      }
    });
  });
});
function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("readBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "View more";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "View less";
    moreText.style.display = "inline";
  }
}

function openSizeChartModal(modal) {
  if (!modal) return;
  modal.style.display = "block";
  var element = document.getElementById("sf-theme");
  if (element) element.classList.add("size_popup_overlay");
  $(".section-my").hide();
  $(".collapsible__button").css('position', 'static');
  $(".slick-slider").css('z-index', '-1');
  $(".product-mb__media").css('z-index', '-1');
  $(".sf-footer").css('position', 'relative');
  $(".sf-footer").css('z-index', '-1');
  $(".f-img-loaded").css('z-index', '-1');
  $(".swiper-container").css('z-index', '-1');
  $(".sf__ms").css('z-index', '-1');
  $(".jdgm-row-actions").css('z-index', '-1');
  $(".jdgm-rev-widg__body").css('z-index', '-1');
  $(".collection-list .collection-list__wrapper").css('z-index', '-1');
  $("#shopify-section-template--15908933632138__product-recommendations").css('display', 'none');
  $(".fixed_header").css('position', 'relative !important');
}

function closeSizeChartModal(modal) {
  if (!modal) return;
  modal.style.display = "none";
  var element = document.getElementById("sf-theme");
  if (element) element.classList.remove("size_popup_overlay");
  $(".section-my").show();
  $(".collapsible__button").css('position', 'relative');
  $(".slick-slider").css('z-index', '1');
  $(".product-mb__media").css('z-index', '1');
  $(".sf-footer").css('position', 'unset');
  $(".sf-footer").css('z-index', '1');
  $(".f-img-loaded").css('z-index', '1');
  $(".sf__ms").css('z-index', '1');
  $(".jdgm-row-actions").css('z-index', '1');
  $(".jdgm-rev-widg__body").css('z-index', '1');
  $(".collection-list .collection-list__wrapper").css('z-index', '1');
  $(".swiper-container").css('z-index', '1');
  $("#shopify-section-template--15908933632138__product-recommendations").css('display', 'block');
  $(".fixed_header").css('position', 'fixed !important');
}

function initSizeChartModal(modalId, btnId) {
  var modal = document.getElementById(modalId);
  var btn = document.getElementById(btnId);
  if (!modal) return;

  if (btn) {
    btn.onclick = function () {
      openSizeChartModal(modal);
    };
  }

  var closeBtn = modal.querySelector('.size-chart-modal-close');
  if (closeBtn) {
    closeBtn.onclick = function (e) {
      e.stopPropagation();
      closeSizeChartModal(modal);
    };
  }

  modal.onclick = function (e) {
    if (e.target === modal) {
      closeSizeChartModal(modal);
    }
  };
}

initSizeChartModal("myModal", "myModBtn");

if (document.getElementById("free_delivery_popup")) {
  var freemodal = document.getElementById("free_delivery_popup");
  var freebtn = document.getElementById("free_delivery");
  var freespan = document.getElementById("close");

  freebtn.onclick = function () {
    freemodal.style.display = "block";
    var element = document.getElementById("sf-theme");
    element.classList.add("size_popup_overlay");
  }

  freespan.onclick = function () {
    freemodal.style.display = "none";
    var element = document.getElementById("sf-theme");
    element.classList.remove("size_popup_overlay");
  }
  freemodal.onclick = function () {
    freemodal.style.display = "none";
  }
}

if (document.getElementById("pay_on_delivery_popup")) {
  var paymodal = document.getElementById("pay_on_delivery_popup");
  var paybtn = document.getElementById("pay_on_delivery");
  var paypans = document.getElementById("closepay");

  paybtn.onclick = function () {
    paymodal.style.display = "block";
    var element = document.getElementById("sf-theme");
    element.classList.add("size_popup_overlay");
  }

  paypans.onclick = function () {
    paymodal.style.display = "none";
    var element = document.getElementById("sf-theme");
    element.classList.remove("size_popup_overlay");
  }
  paymodal.onclick = function () {
    paymodal.style.display = "none";
  }
}

if (document.getElementById("secure_popup")) {
  var securemodal = document.getElementById("secure_popup");
  var securebtn = document.getElementById("secure");
  var kidspancol = document.getElementById("closesecure");

  securebtn.onclick = function () {
    securemodal.style.display = "block";
    var element = document.getElementById("sf-theme");
    element.classList.add("size_popup_overlay");
  }

  kidspancol.onclick = function () {
    securemodal.style.display = "none";
    var element = document.getElementById("sf-theme");
    element.classList.remove("size_popup_overlay");
  }

  securemodal.onclick = function () {
    securemodal.style.display = "none";
  }
}

initSizeChartModal("modal_kid_size_chart", "mykidBtn");


var $temp = $("<input>");
var $url = $(location).attr('href');

$('.clipboard').on('click', function () {
  $("body").append($temp);
  $temp.val($url).select();
  document.execCommand("copy");
  $temp.remove();
  $(".replace_txt").text("URL copied!");
})

$('.video_code').on('click', function () {
  $("body").append($temp);
  $temp.val($url).select();
  document.execCommand("copy");
  $temp.remove();
})
var modalkid = document.getElementById("modal_kid_size_chart");

function required() {
  var empt = document.form1.text1.value;
  if (empt === "") {
    document.getElementById("display_blank").innerHTML = 'Please Enter The Pin Code';
    document.getElementById("display_data").innerHTML = '';
    return false;
  }
  else if (empt.length > 0 && empt.charAt(0) === '0') {
    document.getElementById("display_blank").innerHTML = 'PIN code cannot start with zero.';
    return false;
  }
  else {
    $.ajax({
      url: "https://app.fashiondream.co.in/b2cfashion/b2c_pincodes.php?pincode=" + empt,
      type: "GET",
      processData: false,
      contentType: false,
      beforeSend: function () {
        $("#sub_process").hide();
        $("#invmessage").html("Sending data...");
      },
      success: function (response) {
        var obj = $.parseJSON(response);
        if (obj.status == 1) {
          document.getElementById("display_data").innerHTML = obj.msg;
        } else {
          document.getElementById("display_data").innerHTML = '';
          document.getElementById("display_blank").innerHTML = obj.msg;
        }
      },
      error: function (xhr, status, error) {
        console.error(xhr);
        document.getElementById("display_blank").innerHTML = "An error occurred: " + error;
      }
    });

    //document.getElementById("display_data").innerHTML = 'Expected delivery in 3-4 days';
    document.getElementById("display_blank").innerHTML = '';
    return true;
  }
}

window.document.onkeydown = function (e) {
  if (!e) {
    e = event;
  }
  if (e.keyCode == 27) {
    lightbox_close();
  }
}

function lightbox_open() {
  var lightBoxVideo = document.getElementById("VisaChipCardVideo");
  window.scrollTo(0, 0);
  document.getElementById('light').style.display = 'block';
  document.getElementById('fade').style.display = 'block';
  lightBoxVideo.play();
}

function lightbox_close() {
  var lightBoxVideo = document.getElementById("VisaChipCardVideo");
  document.getElementById('light').style.display = 'none';
  document.getElementById('fade').style.display = 'none';
  lightBoxVideo.pause();
}
var curHeight = $('.widget-filter__list').height();
$(".more").click(function () {
  var container = $(this).parent('.widget-filter');
  var el = container.find('.widget-filter__list');
  var autoHeight = el.css('height', 'auto').height();
  if (el.hasClass('open')) {
    el.removeClass('open');
    el.height(autoHeight).animate({ height: curHeight }, 1000), $(this).text('... Less -');
  }
  else {
    el.addClass('open');
    el.height(curHeight).animate({ height: autoHeight }, 1000), $(this).text('... More +');
  }
});
function trackorder() {
  var orderno = document.getElementById("orderno").value;
  if (orderno != '') {
    window.open('https://www.delhivery.com/track/package/' + orderno, '_blank');
  } else {
    alert("Please Enter Your AWB No.");
  }
}

function wcpolesaleCheckout() {

  window.wcp_data.action_type = 'checkout';
  if ($("[name='note']").length) {
    window.wcp_data.wcp_cart.note = $("[name='note']")[0].value
  }
  if ($("[name='cart[note]").length) {
    window.wcp_data.wcp_cart.note = $("[name='cart[note]")[0].value
  }
  var invoiceUrlParams = [];
  var noteAttributes = [];
  $("[name^='attributes']").each(function () {
    var attribute = $(this);
    var name = $(this).attr("name");
    name = name.replace(/^attributes\[/i, "").replace(/\]$/i, "");
    var v = {
      name: name,
      value: attribute.val()
    };
    if (v.value == "") {
      return
    }
    switch (attribute[0].tagName.toLowerCase()) {
      case "input":
        if (attribute.attr("type") == "checkbox") {
          if (attribute.is(":checked")) {
            noteAttributes.push(v)
          }
        } else {
          noteAttributes.push(v)
        }
        break;
      default:
        noteAttributes.push(v)
    }
  });
  var orderNote = "";
  if ($("[name='note']").length) {
    orderNote = $("[name='note']")[0].value;
  }
  if ($("[name='cart[note]").length) {
    orderNote = $("[name='cart[note]")[0].value;
  }
  window.wcp_data.wcp_cart.note_attributes = noteAttributes;
  window.wcp_data.wcp_cart.note = orderNote;
  if (orderNote.length) {
    invoiceUrlParams.push("note=" + encodeURIComponent(orderNote))
  }
  if (noteAttributes.length) {
    noteAttributes.map(function (a) {
      invoiceUrlParams.push("attributes" + encodeURIComponent("[" + a.name + "]") + "=" + encodeURIComponent(a.value))
    })
  }

  //localStorage.setItem('wpd_integration_fbt_bundle', '');
  //console.log('window.wcp_data:',window.wcp_data);

  jQuery.ajax({
    url: "https://app.fashiondream.co.in/b2cfashion/draftorder",
    type: "POST",
    dataType: "json",
    contentType: "application/x-www-form-urlencoded",
    data: JSON.stringify(window.wcp_data),
    success: function (res) {
      if (res.succeed == 0) {
        res.invoice_url = '/checkout';
        window.location.href = res.invoice_url;
      } else {
        res.order = res.order.body.draft_order;
        var orderRedirectUrl = res.order.invoice_url;
        if (orderRedirectUrl) {
          if (invoiceUrlParams.length) {
            orderRedirectUrl = orderRedirectUrl += "?" + invoiceUrlParams.join("&");
            if (window.is_wcp_custom_param != undefined && window.is_wcp_custom_param == true) {
              orderRedirectUrl = orderRedirectUrl += "&" + window.wcp_cusome_invoiceUrlParams.join("&");
            }
          } else {
            if (window.is_wcp_custom_param != undefined && window.is_wcp_custom_param == true) {
              orderRedirectUrl = orderRedirectUrl += "?" + window.wcp_cusome_invoiceUrlParams.join("&");
            }
          }
          if (window.wpd_checkout_redirect_delay == undefined || isNaN(window.wpd_checkout_redirect_delay)) {
            window.wpd_checkout_redirect_delay = 500;
          } else {
            window.wpd_checkout_redirect_delay = window.wpd_checkout_redirect_delay < 500 ? 500 : window.wpd_checkout_redirect_delay;
          }
          window.location.href = orderRedirectUrl;
        } else {
          window.location.href = "/checkout";
        }
      }
    },
    error: function (e) {
      if (e && e.status === 202) {

      } else {
        if (e.responseText) {
          $('#b2berror').html(e.responseText);
        }
      }
    },
  });
}
function copyText(element) {
  var range, selection, worked;

  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  } else if (window.getSelection) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  try {
    document.execCommand('copy');
    alert('Code copied');
  }
  catch (err) {
    alert('unable to copy code');
  }
}
function copytexts(element) {
  var range, selection, worked;

  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  } else if (window.getSelection) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  try {
    document.execCommand('copy');
    alert('Code copied');
  }
  catch (err) {
    alert('unable to copy code');
  }
}



function init() {
  document.addEventListener("touchstart", touchHandler, true);
  document.addEventListener("touchmove", touchHandler, true);
  document.addEventListener("touchend", touchHandler, true);
  document.addEventListener("touchcancel", touchHandler, true);
}


function isTouchSupported() {
  var msTouchEnabled = window.navigator.msMaxTouchPoints;
  var generalTouchEnabled = "ontouchstart" in document.createElement("div");

  if (msTouchEnabled || generalTouchEnabled) {
    return true;
  }
  return false;
}

if (isTouchSupported()) {
  init();
}

